<template>
    <v-expansion-panel class="expansion-panel">
        <v-expansion-panel-content
            disable-icon-rotate
            v-for="row in rows"
            :key="row"
            :class="contentClass"
        >
            <template v-slot:actions>
                <v-icon :color="iconColor" class="expand-icon">{{icon}}</v-icon>
            </template>

            <template v-slot:header>
                <slot :name="`title-${row}`"/>
            </template>

            <v-card>
                <slot :name="`content-${row}`"/>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
export default {
    props: {
        rows: {
            type: Number,
            required: true,
        },
        contentClass: String,
        iconColor: {
            type: String,
            default: 'primary'
        },
        icon: {
            default: '$vuetify.icons.add',
        },
    },
};
</script>

<style>
    .expansion-panel .v-expansion-panel__container .expand-icon {
        transform: rotate(0deg) !important;
    }

    .expansion-panel .v-expansion-panel__container--active .expand-icon {
        transform: rotate(45deg) !important;
    }
</style>